import React from 'react';
import './ConsultationRoom.css';
import consultationImg from './assets/consultation.jpg';

const ConsultationRoom = () => {
  return (
    <div className="consultation-room-page">
      {/* Hero Image with Overlay */}
      <section className="hero-section">
        <div className="hero-image-wrapper">
          <img src={consultationImg} alt="Consultation Room" className="hero-image" />
          <div className="overlay-text">
            <h1>Welcome to the Consultation Room</h1>
            <p>Meet our clinical officer for a detailed health review, diagnosis, and expert guidance on your care journey.</p>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="video-section">
        <h2>🎥 A Word from Our Clinical Officer</h2>
        <p className="video-caption">
          Watch as our clinical officer walks you through what to expect during your consultation session.
        </p>
        <div className="video-wrapper">
          <video
            controls
            playsInline
            preload="metadata"
            className="consultation-video"
          >
            <source
              src="https://res.cloudinary.com/dfbgpqygq/video/upload/v1751521552/video3_vime27.mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
      </section>

      {/* FAQs */}
      <section className="faq-section">
        <h2>🧠 Frequently Asked Questions (FAQs)</h2>
        <ul className="faq-list">
          <li>
            <span className="faq-question">What happens in the consultation room?</span><br />
            <span className="faq-answer">
              The clinical officer discusses your symptoms, reviews any test results, performs a physical exam if needed, and provides a treatment plan or referrals.
            </span>
          </li>
          <li>
            <span className="faq-question">Do I need to come with my test results?</span><br />
            <span className="faq-answer">Yes, bringing your results helps the clinical officer understand your health better and make informed decisions.</span>
          </li>
          <li>
            <span className="faq-question">How long does a consultation take?</span><br />
            <span className="faq-answer">Typically 10 to 20 minutes, depending on your condition and discussion depth.</span>
          </li>
          <li>
            <span className="faq-question">Is everything discussed confidential?</span><br />
            <span className="faq-answer">Yes, all consultations are private and handled with utmost confidentiality and professionalism.</span>
          </li>
        </ul>
      </section>
    </div>
  );
};

export default ConsultationRoom;
